import React from 'react';


import {Collapse, CollapseItem} from 'element-react';
import {Button} from '@jd/find-react';

 

import KeeVue from '../base/KeeVue.js'

 

import $ from 'jquery';
 

import FsTree from '../element/FsTree.js'
import FsTreeMenu from "../element/FsTreeMenu";
import FsBuildPages from './FsBuildPages'
import FsBuildTemplate  from './FsBuildTemplate'


export default class FsBuildLeft extends KeeVue {
    constructor(props) {
        super(props);

        // this.onMousedown = this.onMousedown.bind(this);
        // this.showSelectComponent = this.showSelectComponent.bind(this);


        this.state = {
            randId: this.getRandString(),
            activeLeftTab: 'left1',
            keeVueComponents: [],
            layoutList: [],
            formList: [],
            zhanshiList: [],
            businessList: [],
            businessMingjingList: [],
            businessXaList: [],
            showFlag1: true,
            showFlag2: false,
            showFlag3: false,
            showFlag4: false,
            showFlag5: false,
            showFlag6: false,
            componentTypes: [{}, {}],
            loadedComponentTypes: ['layout', 'form', 'zhanshi','business'],
            activeName: '0',
            leftTab:(window.isReport?1:3),
            changeTime: 0,
			refreshVersion:0,
        };

    }

    componentDidMount() {
        this.loadData();
        this.onEvent("drag", this.onDrag);
        this.onEvent("draging", this.onDraging);
        this.onEvent("droped", this.onDroped);
        this.onEvent("topHelp", (p1, p2) => {
            alert("left rev help" + p1 + p2)
        });

        this.onEvent("right.changePage", ()=>{this.refresh()});

		// 刷新元素
		this.onEvent("componentsChange",()=>{ 
				if(this.state.leftTab === 2)
				{
					this.state.refreshVersion++; this.refresh()
				}
			});

    }

    selectItem() {
    }

    selectType = (dict) => {
        for (let i = 0; i < this.state.componentTypes.length; i++) {
            if (this.state.componentTypes[i].value === dict.value) {
                this.state.componentTypes[i].showFlag = true;
            } else {
                this.state.componentTypes[i].showFlag = false;
            }
        }
    }
	
	showComponentList=()=>{
				
					this.openBottomPage("M::jdcc.vueComponent/list&id=",{
						withHeader:true,
						title:'组件管理'
					});
				
		}
				
    showSelectComponent = () => {
        let types = "";
        let that = this;
        for (let i = 0; i < this.state.componentTypes.length; i++) {
            if (this.state.componentTypes[i].isShow === true) {
                types += this.state.componentTypes[i].value + ",";
            }
        }
        this.openDlgPage("M::jdcc.vueComponent/selectComponent&id=", {
            title: '选择要显示的组件',
            size: '800',
           
            top: "10vh",
            loadUrl: '',
            extraParas: {
                id: 'componentType',
                types: types,
            },
            onChanged(ret, form) {
                if (ret.data !== null) {
                    ret.data.types += ",";
                    let cacheStrKey = ret.data.types;
                    ret.data.types = "," + ret.data.types;
                    for (let t = 0; t < that.state.loadedComponentTypes.length; t++) {
                        if (ret.data.types.indexOf("," + that.state.loadedComponentTypes[t] + ",") !== -1) {
                            ret.data.types = ret.data.types.replace("," + that.state.loadedComponentTypes[t] + ",", ",");
                        }
                    }
                    for (let m = 0; m < that.state.componentTypes.length; m++) {
                        if (ret.data.types.indexOf("," + that.state.componentTypes[m].name + ",") !== -1 || that.state.componentTypes[m].name === 'layout' || that.state.componentTypes[m].name === 'form' || that.state.componentTypes[m].name === 'zhanshi'|| that.state.componentTypes[m].name === 'business') {
                            that.state.componentTypes[m].isShow = true;
                        } else {
                            that.state.componentTypes[m].isShow = false;
                        }
                    }
                    ret.data.types = ret.data.types.replace(",", "");
                    if (ret.data.types !== '' && ret.data.types !== ',') {
                        $.ajax({
                            url: "https://deploy-sh.xjoycity.com/api/vueComponentJs/getByCombineBusinessJsWithType?typeNames=" + ret.data.types,
                            cache: true,
                            type: 'get',
                            dataType: "html",
                            data: {},
                            success(str) {
                                let oHead = document.getElementsByTagName('HEAD').item(0);
                                let oScript = document.createElement("script");
                                oScript.type = "text/javascript";
                                oScript.text = str;
                                oHead.appendChild(oScript);
                                let newTypes = ret.data.types.split(",");
                                for (let n = 0; n < newTypes.length; n++) {
                                    if (newTypes[n] !== '') {
                                        that.state.loadedComponentTypes.push(newTypes[n]);
                                    }
                                }
                            },
                            error(XMLHttpRequest, textStatus, errorThrown) {
                                console.log("设置值错误：" + module.url);
                                console.log("网络请求错误")
                                module.data = "";
                            }
                        });
                        $.ajax({
                            url: "https://deploy-sh.xjoycity.com/api/vueComponentJs/getByCombineBusinessCssWithType?typeNames=" + ret.data.types,
                            cache: true,
                            type: 'get',
                            dataType: "html",
                            data: {},
                            success(str) {
                                let nod = document.createElement("style");
                                nod.type = "text/css";
                                if (nod.styleSheet) { //ie下
                                    nod.styleSheet.cssText = str;
                                } else {
                                    nod.innerHTML = str; //或者写成 nod.appendChild(document.createTextNode(str))
                                }
                                document.getElementsByTagName("head")[0].appendChild(nod);
                            },
                            error(XMLHttpRequest, textStatus, errorThrown) {
                                console.log("设置值错误：" + module.url);
                                console.log("网络请求错误")
                                module.data = "";
                            }
                        });
                    }
                    let strKey = "componentTypeKey";
                    let storage = window.localStorage;
                    storage.setItem(strKey, cacheStrKey);
                    for (let i = 0; i < that.state.componentTypes.length; i++) {
                        if (cacheStrKey.indexOf(that.state.componentTypes[i].value + ",") !== -1) {
                            that.state.componentTypes[i].isShow = true
                        } else {
                            that.state.componentTypes[i].isShow = false;
                        }
                    }
                }
                form.$emit("command", "close");
            }
        })
    }
    showComponentSource = (item) => {
        let that = this;
        if (item.type !== "business" && item.type.indexOf("business") === -1 && item.type !== "zhanshi") {
            alert("只支持业务类组件在线编辑源码！");
            return;
        } 
		 
        that.openRightPage("M::jdcc.vueComponent/jsForm&id=" + item.id, {
            title: item.name + '组件源码',
            size: 'large',
            width: '70%',
            top: "1vh",
            loadUrl: '/keeVueComponent/get?id=' + item.id,
            extraParas: {
                id: item.id
            },
            onChanged(ret, form) {
                that.showMessage(ret);
                form.$emit("command", "close");
            }
        })
    }
    showComponentProperty = (item) => {

        this.sendEvent("showComponentProperty", item, item);
    }
    setActiveComponent = (item) => {


        this.$emit("selectComponent", item);


    }
    getTargetComponentId = (event) => {
        let target = event.target;
        let boxid = event.target.getAttribute("boxid");
        if (boxid && boxid !== '') {
            return null;
        }
        let tid = event.target.getAttribute("tid");
        let fromBox = event.target;
        if (tid === null) {
            let parent = event.target.parentNode;
            while (parent && typeof parent.getAttribute === "function") {
                boxid = parent.getAttribute("boxid");
                if (boxid && boxid !== '') {
                    return null;
                }
                tid = parent.getAttribute("tid");
                if (tid) {
                    return parent
                    break;
                } else {
                    parent = parent.parentNode;
                }
            }
        }
        return event.target;
    }
    onMousedown = (event) => {
		if(this.state.leftTab !== 1 )
		{
			return ;
		}
        console.log("左侧树的触发");
        this.sendEvent("clearSelectState");
        let toTarget = this.getTargetComponentId(event);
        let toTargetId = null;
        if (toTarget) {
            toTargetId = toTarget.getAttribute("tid");
        }
        if (toTargetId !== null) {
			
			// 设置为可以横向移动
			this.sendEvent("drag.enableX");
			
            for (let i = 0; i < this.state.keeVueComponents.length; i++) {
                if (this.state.keeVueComponents[i].id === toTargetId) {
					
					
					
                    let that = this;
                    let item = this.state.keeVueComponents[i];
					let houzhui="";
					if(window.isReport)
					{
						houzhui="-report";
					}
                    if (!window.allPropConfig[item.name + "-prop-form"+houzhui]) {
                        console.log("/keePage/getComponentPropForm?code=" + item.name+"&houzhui="+houzhui);
                        this.doRequest("/keePage/getComponentPropForm?code=" + item.name+"&houzhui="+houzhui, function (ret) {
                            for (let p in ret) {
                                window.allPropConfig[p] = ret[p];
                            }
                        });
                    }
                    console.log("新组件：：：：：" + JSON.stringify(item));
                    if (item.type === 'layout' ||   item.type === 'form') {
                        this.sendEvent("drag.selectstart", false);
                        this.sendEvent("drag.select", event, true);
                    } else {
                        let that = this;
						 
                        this.loadPageComponents(item.name, function () {
                            that.sendEvent("drag.selectstart", false);
                            that.sendEvent("drag.select", event, true);
                        });
                    }
                }
            }
        }
    }
    onDrag = (obj) => {
        //alert("收到drag"+obj.boxid);
        if (this.state.keeVueComponents && obj.boxid === 'fs-build-left1') {


            let list = this.state.keeVueComponents;
            for (let j = 0; j < list.length; j++) {
                if (list[j].id === obj.tid) {
                    list[j].isFloat = true;
                    //alert(list[j].name);
                    //alert("收到drag11111")
                    obj.callback(JSON.parse(JSON.stringify(list[j])));
                    return;
                }
            }
        }
    }
    onDraging = (obj) => {
    }
    onDroped = (obj) => {
    }

    changeLeftTab = (tab) => {
        this.state.activeLeftTab = tab.name;
    }
    loadData = () => {
        let that = this;
		 
		// 获取组件列表
        this.doRequest("/keeVueComponent/listData?search_EQ_isActive=1&search_EQ_isDel=0&order=asc&sort=seq&"+
		"fields=name,title,icon,type,isActive,seq,formConfigJson,isContainer,functions,events", function (ret) {
            if (ret.rows) {
                for (let n = 0; n < ret.rows.length; n++) {
                    let t = ret.rows[n];
                    if (that.isNotBlank(t.events)) {
                        t.events = JSON.parse(t.events);
                    } else {
                        t.events = [];
                    }
                }
                that.doRequest("/sysDict/getOptions?name=componentType", function (dicts) {
                    for (let i = 0; i < dicts.length; i++) {
						if(window.isReport)
						{
						if ( 'form'  === dicts[i].value ) {
						     dicts[i].title="基础组件";
						} 
						else
						{
							dicts.remove(dicts[i]);
							i--;
							continue;
						}
						
						}
						
                        dicts[i].showFlag = (i === 0);
                        if (i % 4 === 0)
                            dicts[i].background = "#2C68FF";
                        if (i % 4 === 1)
                            dicts[i].background = "#13CE66";
                        if (i % 4 === 2)
                            dicts[i].background = "#F7BA2A";
                        if (i % 4 === 3)
                            dicts[i].background = "#FF7800";
                        dicts[i].list = [];
                        if (i < 3) {
                            dicts[i].isShow = true;
                        } else {
                            dicts[i].isShow = false;
                        }
                        for (let n = 0; n < ret.rows.length; n++) {
                            let t = ret.rows[n];
							
							if(window.isReport)
							{
								if (t.type === 'form'&&t.type === dicts[i].value) {
									
									// 排除不需要的组件
									if(",fs-code-editor,fs-cascader,fs-grouping,fs-img,fs-uploader,fs-switch,fs-cms-config,fs-color,fs-html-editor,fs-roles-body,fs-users-body,fs-ztree-body,fs-ztree,fs-roles,fs-users,fs-icon,fs-qr,fs-rate,".indexOf(t.name)!=-1)
									{
										continue;
									}
								    dicts[i].list.push(t);
									
									 
									let houzhui ="-report";
									 
								  
									//console.log("/keePage/getComponentPropForm?code="+name+"   randId:"+this.state.randId);
									this.doRequest("/keePage/getComponentPropForm?code="+t.name+"&houzhui="+houzhui,function(ret){ 
										for(let p in ret)
										{
											window.allPropConfig[p]=ret[p];
										} 
									});
									 
									
								} 
								// if (t.type === 'layout'&&t.type === dicts[i].value) {
									
								// 	dicts[i].title='基础';
								// 	if(t.name=='el-button')
								// 	{
								// 	   dicts[i].list.push(t);	
								// 	}
								   
								// } 
							}
							else
							{
								if (t.type === dicts[i].value) {
								    dicts[i].list.push(t);
								}
							}
							
                            
                        }
                    }
                    that.state.componentTypes = dicts;
					
					if(window.isReport)
					{
						// 是报表模式
						
						
						let componentList=[];
						
						for (let n = 0; n < ret.rows.length; n++) {
						    let t = ret.rows[n];
							if(t.name=='fs-cascader')
							{
								t.title="省市区"; 
								
								if(window.ServerConfig&&window.ServerConfig.shengShiQuTitle)
								{
									t.title = window.ServerConfig.shengShiQuTitle;
								}
								
								componentList.push(t);
								let ssqhouzhui ="-report";
								//console.log("/keePage/getComponentPropForm?code="+name+"   randId:"+this.state.randId);
								this.doRequest("/keePage/getComponentPropForm?code="+t.name+"&houzhui="+ssqhouzhui,function(ret){ 
									for(let p in ret)
									{
										window.allPropConfig[p]=ret[p];
									} 
								});
								
							}
                            if(t.name === 'fs-card')
							{
								t.title="分组";
								
								componentList.push(t);
								let kphouzhui ="-report";
								//console.log("/keePage/getComponentPropForm?code="+name+"   randId:"+this.state.randId);
								this.doRequest("/keePage/getComponentPropForm?code="+t.name+"&houzhui="+kphouzhui,function(ret){ 
									for(let p in ret)
									{
										window.allPropConfig[p]=ret[p];
									} 
								});
								
							}
						}
						
						that.state.componentTypes.push(
                            {
                                name:'gaoji',
                                title:'高级组件',
                                list:componentList
                            }
                        )
						
					}
					
                    let strKey = "componentTypeKey";
                    let storage = window.localStorage;
                    if (storage.getItem(strKey) !== null) {
                        let typesValue = storage.getItem(strKey);
                        for (let i = 0; i < that.state.componentTypes.length; i++) {
                            if (typesValue.indexOf(that.state.componentTypes[i].value + ",") !== -1) {
                                that.state.componentTypes[i].isShow = true
                            } else {
                                that.state.componentTypes[i].isShow = false;
                            } 
                        }
                    }

                    that.setState(that.state);
                });
                that.state.keeVueComponents = ret.rows;
                //console.log(JSON.stringify(that.state));
                //alert(JSON.stringify(that.state));
                that.setState(that.state);
            }
        });
    }

    renderReportItem = (item, index) => {
        return <div key={index}   id={'item' + item.id}  tid={item.id}
                    className={`${item.select ? 'kee-fs-list-select' : ''}`} onClick={()=>{ this.sendEvent('addItem',item)}}
                    style={{'border': '0', 'display': 'inline-block', 'width': '130px',position: ' relative'}}> 
                <div className={`kee-component-list-item`} style={{textAlign:'left',marginLeft:'20px',lineHeight:'40px'}}>
                    <i className={`${item.icon}`}>
                    </i>
                    
                   <span  style={{marginLeft:'8px'}}>   {item.title}</span>
                     
                </div>
 
        </div>
    }
	
	renderItem = (item, index) => {
	    return <div key={index}   id={'item' + item.id}  tid={item.id}
	                className={`${item.select ? 'kee-fs-list-select' : ''}`}
	                style={{'border': '0', 'display': 'inline-block', 'width': '90px',position: ' relative'}}> 
	            <div className={`kee-component-list-item`}  >
	                <i className={`${item.icon}`}>
	                </i>
	                <div >
	                    {item.title} 
	                </div> 
	            </div>
	 
	    </div>
	}
	

    shouldComponentUpdate(nextProps, nextState) {

        // if (this.lastStateString === JSON.stringify(nextState)) {
        //     return false;
        // }
        return true;

        //  if (nextState.componentTypes===this.state.componentTypes) {

        //    return false;
        //  }
        //  return true;
    }


    render() {
        this.lastStateString = JSON.stringify(this.state);
        return (

            <div style={{position: ' relative', width: ' 100%', height: ' 100%'}} id={this.state.randId}
                 className={`jdcc-disable-select`}>

				{!window.isReport&& <div   className={`jdcc-disable-select  editor-main-left  top-btns`}>
				
					 <div>
						{
							!window.isReport&&<div className={`build-left-tab-item ${this.state.leftTab === 3 ? 'active' : ''}`}
								 onClick={() => {
									 this.state.leftTab = 3;
									 this.setState(this.state)
								 }}>
								<div>
									<i className={`fa fa-file-o `}>
									</i>
								</div>
								<div>
									页面
								</div>
							</div>
						}
					</div>
                    <div>
                        
						   <div className={`build-left-tab-item ${this.state.leftTab === 1 ? 'active' : ''}`}
                             onClick={() => {
                                 this.state.leftTab = 1;
                                 this.setState(this.state)
                             }}>
                            <div>
                                <i className={`fa fa-cubes`}>
                                </i>
                            </div>
                            <div>
                                组件
                            </div>
                        </div>
					    
                    </div>
                    <div>
                      {
						  !window.isReport&&<div className={`build-left-tab-item ${this.state.leftTab === 2 ? 'active' : ''}`}
                             onClick={() => {
                                 this.state.leftTab = 2;
                                 this.setState(this.state)
                             }}>
                            <div>
                                <i className={`glyphicon glyphicon-th-list`}>
                                </i>
                            </div>
                            <div>
                                元素
                            </div>
                        </div>
					  }  
                    </div>
                   
                    <div>
                        <div className={`build-left-tab-item ${this.state.leftTab === 4 ? 'active' : ''}`}
                             onClick={() => {
                                 this.state.leftTab = 4;
                                 this.setState(this.state)
                             }}>
                            <div>
                                <i className={`fa fa-film`}>
                                </i>
                            </div>
                            <div>
                                模板
                            </div>
                        </div>
                    </div>
                </div>
				}
               
                <div style={{
                    position: ' absolute',
                    left: (window.isReport?0:'60px'),
                    right: ' 0',
                    top: ' 0',
                    bottom: ' 0',
                    borderLeft: '0',
					padding:'5px'
                }}>
                    <div onMouseDown={ this.onMousedown } style={{
                        position: ' absolute',
                        left: ' 0px',
                        top: ' 0px',
                        right: ' 0px',
                        bottom: ' 0px',
                        overflow: ' auto'

                    }}>
                        <div ref={(input) => {window.domTargets.left = input}} style={{cursor: ' default', display: (this.state.leftTab === 1 ? 'block' : 'none')}}
                             boxid="fs-build-left1">
							 {!window.isReport&&window.ClientInsConfig&&!window.ClientInsConfig.disablePublish&&
								 <div style={{textAlign: ' left',padding:'12px'}}>
									 <Button   onClick={this.showSelectComponent}>
										 选择组件
									 </Button>
									
									<Button style={{'float':'right'}}  onClick={this.showComponentList}>
										组件管理
									</Button>
								 </div>
							 }
                           

							{
								<Collapse value={this.state.activeName}   onChange={(act) => {
								    this.state.activeName = act
								}}>
								
								    {
								        (this.state.componentTypes.map((dict, index) => {
								            return <Collapse.Item title={dict.title}  key={index} name={"" + index}>
								                {
													dict.list&&dict.list.map((item,index)=>{
														if(window.isReport)
														{ 
															return this.renderReportItem(item,index);
														}
														
														return this.renderItem(item,index);
														}) 
												}
												
								            </Collapse.Item>
								        }))
								    }
								
								</Collapse>
							}
                           


                        </div>
						{
							!window.isReport&&<div style={{cursor: ' default',padding:'8px', display: (this.state.leftTab === 2 ? 'block' : 'none')}}>
							    <FsTreeMenu treeData={this.props.components} refreshVersion={this.state.refreshVersion} onSelect={this.setActiveComponent}
							           canDrop={true} onDblClick={this.showComponentProperty} titleField="name" from="edit"  isShowMenu={this.state.leftTab === 2 }
							            isMenu={true} onDrop={(info)=>{ this.sendEvent("leftTreeDrop",info)}} valueField="id" childField="child"></FsTreeMenu>
							    
							 
							</div>
						}
                        
						{
							 <div style={{cursor: ' default',padding:'8px', display: (this.state.leftTab === 3 ? 'block' : 'none')}}>

                            <FsBuildPages appid={this.props.appid}></FsBuildPages>

                        </div>
						}
                        
                        <div style={{cursor: ' default',padding:'18px', display: (this.state.leftTab === 4 ? 'block' : 'none')}}>

                             <FsBuildTemplate ></FsBuildTemplate >

                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
